import type { RouteRecordRaw } from 'vue-router';

/**
 * Desktop workstation screen (WP7.8b, ADR-085 Amendment): offline sync queue, label printer, serial
 * scanner and reference-cache status. Reachable in the browser too (it explains it is desktop-only) but
 * only listed in the nav inside the Tauri shell.
 */
export const desktopRoutes: RouteRecordRaw[] = [
  {
    path: 'desktop/sync',
    name: 'desktop-sync',
    component: () => import('../pages/desktop/DesktopSyncPage.vue'),
  },
];
